import React from "react";
import { Container, Typography, Link, Paper } from "@mui/material";

export const TermsOfUsePage = () => {
  return (
    <Container maxWidth="md" component="main">
      <Paper elevation={3} sx={{ p: 4, mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Terms of Use for Rotten Egg
        </Typography>
        <Typography variant="body1" paragraph>
          Last updated: 28/04/2024
        </Typography>
        
        <Typography variant="body1" paragraph>
          By accessing and using Rotten Egg, you agree to these Terms of Use. If you do not agree with any part of these terms, you must not use our game.
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>Intellectual Property</strong>
          <br />
          The content, features, and functionality of Rotten Egg are owned by or licensed to us and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws. You may not modify, reproduce, distribute, create derivative works of, publicly display, publicly perform, republish, download, store, or transmit any of the material on our game.
        </Typography>

        <Typography variant="body1" paragraph>
          <strong>Prohibited Uses</strong>
          <br />
          In addition to other prohibitions as set forth in the Terms of Use, you are prohibited from using Rotten Egg or its content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c) to violate any international, federal, provincial, or state regulations, rules, laws, or local ordinances; (d) to infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual orientation, religion, ethnicity, race, age, national origin, or disability; (f) for any obscene or immoral purpose; or (g) to interfere with or circumvent the security features of Rotten Egg or any related website, other websites, or the internet.
        </Typography>

        {/* ... more sections of the terms of use ... */}

        <Typography variant="body1" paragraph>
          These Terms of Use and any policies or operating rules posted by us on Rotten Egg constitute the entire agreement and understanding between you and us and govern your use of Rotten Egg, superseding any prior or contemporaneous agreements, communications, and proposals, whether oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Use).
        </Typography>

        <Typography variant="body1" paragraph>
          Any ambiguities in the interpretation of these Terms of Use shall not be construed against the drafting party.
        </Typography>

        <Typography variant="h6" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about these Terms of Use, please contact us.
        </Typography>
        
        {/* Example of a link to contact */}
        <Link href="mailto:rc@cenedex.com" variant="body1">
          rc@cenedex.com
        </Link>
      </Paper>
    </Container>
  );
};
